import { createSelector } from "reselect";
import slice from "./slice";

export const selectRecommendedDatasources = createSelector(
  slice.selector,
  (state) => state.entity.recommendedDatasources,
);
